import type { Nullable } from 'corgi-types';

import type { ProductDetails } from '../components/types';

const IS_LINE_NO_REGEX = /^[0-9]{3,4}$/;

export const LINE_NO_SEPARATOR = '|';

export const extractLineNoList = (products: ProductDetails[]) =>
  products.map(({ lineNo }) => lineNo);

export const isAllSelected = (products: string[], selectedProducts: string[]) => {
  if (products.length !== selectedProducts.length) {
    return false;
  }

  return products.every(item => selectedProducts.includes(item));
};

const productsFromLineNumberString = (lineNumbers: string, products: ProductDetails[]) => {
  if (!lineNumbers || !products.length) {
    return [];
  }

  const lineNoList = lineNumbers.split(LINE_NO_SEPARATOR);

  return lineNoList.map(selectedLineNo => products.find(({ lineNo }) => lineNo === selectedLineNo));
};

export const getProductSummary = (lineNumbers: string, products: ProductDetails[]) => {
  const selectedProducts = productsFromLineNumberString(lineNumbers, products);

  if (!selectedProducts.length) {
    return '';
  }

  const productNames = selectedProducts
    .map(product => product?.article?.name)
    .filter((name): name is NonNullable<typeof name> => Boolean(name));

  return productNames.join(', ');
};

export const getProductThumbnails = (lineNumbers: string, products: ProductDetails[]) =>
  productsFromLineNumberString(lineNumbers, products)
    .map(product => ({
      thumbnail: product?.article?.images[0]?.path ?? null,
      alt: product?.article?.name ?? null,
    }))
    .filter(
      (
        product
      ): product is {
        thumbnail: string;
        alt: string;
      } => Boolean(product.thumbnail)
    );

export const hasLineNo = (str: Nullable<string>) => {
  if (!str) {
    return false;
  }

  const [lineNo] = str.split(LINE_NO_SEPARATOR);

  return IS_LINE_NO_REGEX.test(lineNo);
};
